import React from 'react'
import { LoadingFeedback } from 'V2Components'
import { SummaryHeader } from 'features/resources'
import { TargetIcon, ResponsiveTable } from 'procyon-ui'
import { useADDomainPasswords, columns } from './ADDomainControllers.utils'

const ADDomainControllersUser = () => {
  const { tableData, editingRow, setEditingRow, handleEdit, handleCancel, handleSave, isLoading } =
    useADDomainPasswords()

  return (
    <div>
      {/* Header */}
      <div className='-mx-4 -mt-6 p-4'>
        <SummaryHeader
          rsrcName='RDP User Management'
          Icon={(props) => <TargetIcon type='AD_DOMAIN_CONTROLER' {...props} />}
          actions={<></>}
        />
      </div>

      {/* Table */}
      <div className='p-4 bg-[var(--color-common-bg-base)]'>
        <div className='mt-4'>
          <ResponsiveTable
            columns={columns({
              onEdit: handleEdit,
              onCancel: handleCancel,
              onSave: handleSave,
              editingRow,
              onEditChange: (field, value) => setEditingRow({ ...editingRow, [field]: value })
            })}
            data={tableData}
          />
        </div>
      </div>

      {/* Loading State */}
      <LoadingFeedback caption='Please wait..' loading={isLoading} message='Updating The Data!' />
    </div>
  )
}

export { ADDomainControllersUser }
